import { OnInit, Component, ViewChild, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { SecurityService } from 'app/shared/services/security.service';
import { AppConfig } from 'app/app.config';
import { IDtoEmployee } from 'app/shared/models/employee/dto-employee.model';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ValidatorService } from 'app/shared/services/validator.service';
import { LiquidationService } from 'app/views/appviews/liquidation.service';
import { IDtoLiquidation } from 'app/shared/models/legal/dto-liquidation.model';
import { DiscountService } from 'app/views/appviews/discount.service';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IDtoSettlement } from 'app/shared/models/legal/dto-settlement.model';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { IDtoDocument } from 'app/shared/models/request/dto-document.model';
import { DocumentService } from 'app/shared/services/document.service';
import { IdentityService } from 'app/views/appviews/security/identity.service';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { DatePipe } from '@angular/common';
import { EmailService } from 'app/views/appviews/email.service';
import { IDtoEmail } from 'app/shared/models/dto-email.model';
@Component({
    selector: '[liquidation-detail]',
    styleUrls: ['liquidation-detail.style.scss'],
    templateUrl: 'liquidation-detail.template.html'
})
export class LiquidationDetailComponent implements OnInit, OnChanges {
    amountCustomer = 0;
    amountOwner = 0;
    private file: File;
    private fileName = '';
    private document = {} as IDtoDocument;

    private validator = ValidatorService;
    private fsaFlags = [false];
    private errorMessages: any;
    /**Formularios */
    private showRoles: any;
    private employeeIniId: number;
    private profile: string;
    private formLiquidationDetail = {} as FormGroup;
    private liquidation: IDtoLiquidation;
    private settlement: IDtoSettlement;
    private toolDiscounts: IDtoCatalog[];
    private liquidationId: number;
    private approver: string;
    private desactiveControls: boolean;
    @ViewChild('confirmSwal', { static: false }) private confirmSwal: SwalComponent;
    @Input() private employeeData: IDtoEmployee;
    @Input() private module: string;
    @Input() private actionLiquidation: string;
    @Output() dataLiquidation = new EventEmitter<IDtoLiquidation>();
    private approvalConciliationOwnSent: boolean;
    constructor(private spinner: NgxSpinnerService
        , private securityService: SecurityService
        , private configGeneral: AppConfig
        , private formBuilder: FormBuilder
        , private liquidationService: LiquidationService
        , private discountService: DiscountService
        , private route: ActivatedRoute
        , private configurationService: ConfigurationService
        , private documentService: DocumentService
        , private identityService: IdentityService
        , private datePipe: DatePipe
        , private emailService: EmailService) {
        this.showRoles = this.securityService.getUserRolesStorage();
        if (this.showRoles !== '') {
            this.employeeIniId = this.showRoles.employeeId;
        }
    }
    ngOnInit(): void {
        this.initializeFormLiquidation();
        if (this.configurationService.isReady) {
            this.getApproverConciliationOwn();
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.getApproverConciliationOwn();
            });
        }
        this.route.params.subscribe((params) => {
            if (params['liquidationId']) {
                setTimeout(() => {
                    if (this.configurationService.isReady) {
                        this.liquidationId = params['liquidationId'];
                        this.getLiquidationById();
                    } else {
                        this.configurationService.settingsLoaded$.subscribe(x => {
                            this.liquidationId = params['liquidationId'];
                            this.getLiquidationById();
                        });
                    }
                }, 2);
            }
        });
        this.formLiquidationDetail.get('conciliationOwn').valueChanges.subscribe(value => {
            // Establecer approvalConciliationOwnSent en false cuando cambie el valor del campo
            if(Number(value) != this.liquidation.conciliationOwn) {
                this.approvalConciliationOwnSent = false;
            } else {
                this.approvalConciliationOwnSent = true;
            }
        });
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes.employeeData !== undefined) {
            if (changes.employeeData.currentValue !== undefined && changes.employeeData.currentValue !== null) {
                this.getLiquidationDetail();
            }
        }
        if (changes.actionLiquidation !== undefined) {
            if (changes.actionLiquidation.currentValue !== undefined && changes.actionLiquidation.currentValue !== null) {
                if (this.actionLiquidation != 'update') {
                    this.liquidation = {} as IDtoLiquidation;
                    this.formLiquidationDetail.reset();
                    this.getLiquidation();
                }
            }
        }
    }
    private initializeFormLiquidation() {
        this.formLiquidationDetail = this.formBuilder.group({
            petition: [null],
            conciliationCustomer: [null],
            conciliationOwn: [null],
            recoveredViaticDiscount: [null],
            recoveredToolDiscount: [null],
            recoveredLendingDiscount: [null],
            recoveredOtherDiscount: [null],
            acceptSettlement: [null],
            approvalConciliationOwnSent: [null],
            comment: [null]
        });
    }
    private mapLiquidationData(dto: IDtoLiquidation): IDtoLiquidation {
        if (dto == undefined) {
            dto = {} as IDtoLiquidation;
        }
        let dtoNew = {} as IDtoLiquidation;
        if (this.formLiquidationDetail.value != undefined) {
            dtoNew = this.formLiquidationDetail.value as IDtoLiquidation;
        }
        dto.approvalConciliationOwnSent = dtoNew.approvalConciliationOwnSent == null ? false : dtoNew.approvalConciliationOwnSent;
        dto.moneyRequestSent = dto.moneyRequestSent == null ? false : dto.moneyRequestSent;
        dto.conciliationOwn = dtoNew.conciliationOwn == null ? 0 : dtoNew.conciliationOwn;
        dto.conciliationCustomer = dtoNew.conciliationCustomer == null ? 0 : dtoNew.conciliationCustomer;
        dto.recoveredViaticDiscount = dtoNew.recoveredViaticDiscount == null ? 0 : dtoNew.recoveredViaticDiscount;
        dto.recoveredToolDiscount = dtoNew.recoveredToolDiscount == null ? 0 : dtoNew.recoveredToolDiscount;
        dto.recoveredLendingDiscount = dtoNew.recoveredLendingDiscount == null ? 0 : dtoNew.recoveredLendingDiscount;
        dto.recoveredOtherDiscount = dtoNew.recoveredOtherDiscount == null ? 0 : dtoNew.recoveredOtherDiscount;
        dto.acceptSettlement = dtoNew.acceptSettlement == null ? null : dtoNew.acceptSettlement;
        dto.petition = dtoNew.petition == null ? null : dtoNew.petition;
        dto.comment = dtoNew.comment == null ? null : dtoNew.comment
        //dto.approvalConciliationOwnSent = dtoNew.approvalConciliationOwnSent;
        dto.employeeId = dto.employeeId == null ? this.employeeData.id : dto.employeeId;
        dto.employeeNum = this.employeeData.employeeNum;
        dto.employeeCompanyId = this.employeeData.employeeCompanyId;
        dto.dismissalDate = this.employeeData.dismissalDate;
        dto.hiringDate = dto.id > 0  ? dto.hiringDate : this.employeeData.hiringDate;
        dto.jobId = this.employeeData.jobId;
        dto.dailySalary = this.employeeData.dailySalary;
        dto.assimilatedCommission = this.employeeData.assimilatedCommission;
        dto.id = dto.id;
        dto.requisitionId = dto.id > 0  ? dto.requisitionId : this.employeeData.requisitionId;
        dto.customerName = dto.customerName == null ? this.employeeData.employeeMarkName : dto.customerName;
        return dto;
    }
    private getLiquidation(): void {
        // if (!this.formLiquidationDetail.valid) {
        //     this.configGeneral.newToast('Error', 'Seleccione un trabajador para continuar', 'error');
        //     return;
        // }
        this.spinner.show()
        let dto = this.mapLiquidationData(this.liquidation);
        this.liquidationService.getliquidation(dto)
            .subscribe(
                (x) => {
                    if (x.isCorrect) {
                        this.liquidation = x.data as IDtoLiquidation;
                        this.approvalConciliationOwnSent = this.liquidation.approvalConciliationOwnSent;
                        this.liquidation.authenticatedEmployeeId = this.employeeIniId;
                    } else {
                        this.liquidation = {} as IDtoLiquidation;
                        this.configGeneral.newToast('Error', x.message, 'error');
                    }
                    this.spinner.hide();
                },
                (errMessage) => {
                    this.spinner.hide();
                    this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                });
    }
    private getDetailsDescriptionDiscounts(): void {
        this.spinner.show()
        this.discountService.getDetailsDescriptionDiscounts(this.employeeData.employeeNum, this.employeeData.employeeCompanyId)
            .subscribe(
                (x) => {
                    if (x.isCorrect) {
                        this.toolDiscounts = x.data as IDtoCatalog[];
                    } else {
                        this.configGeneral.newToast('Error', x.message, 'error');
                    }
                    this.spinner.hide();
                },
                (errMessage) => {
                    this.spinner.hide();
                    this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                });
    }
    private getDetailSettlementEmployee(dto: IDtoLiquidation): void {
        this.spinner.show()
        this.liquidationService.getDetailSettlementEmployee(dto)
            .subscribe(
                (x) => {
                    if (x.isCorrect) {
                        this.settlement = x.data as IDtoSettlement;
                    } else {
                        this.configGeneral.newToast('Error', x.message, 'error');
                        this.liquidation = {} as IDtoLiquidation;
                    }
                    this.spinner.hide();
                },
                (errMessage) => {
                    this.spinner.hide();
                    this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                });
    }
    private submitForm(): void {
        if (this.formLiquidationDetail.valid) {
            let status = this.formLiquidationDetail.value.acceptSettlement;
            if (status == null) {
                this.confirmSwal.title = 'La liquidación será guardada con estatus PENDIENTE';
            } else if (status == true) {
                this.confirmSwal.title = 'La liquidación será guardada con estatus ACEPTADA POR EL TRABAJADOR';
            } else {
                this.confirmSwal.title = 'La liquidación será guardada con estatus RECHAZADA POR EL TRABAJADOR';
            }
            this.confirmSwal.show().then((result) => {
                if (result.value) {
                    if (this.liquidation.id > 0) {
                        this.updateLiquidation();
                    } else {
                        this.saveLiquidation();
                    }
                }
            });
        } else {
            this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'error');
        }
    }
    private saveLiquidation(): void {
        let dto = this.mapLiquidationData(this.liquidation);
        if (dto.conciliationCustomer > 0) {
            if (this.file == undefined) {
                this.configGeneral.newToast('Validación', 'Seleccione un archivo como soporte de autorización de conciliación del cliente.', 'error');
                return;
            }
        }
        if (dto.conciliationOwn > 0) {
            if (this.approver == undefined) {
                this.configGeneral.newToast('Validación', 'No existe un aprovador disponible para realizar la aprobación de la conciliación propia.', 'error');
                return;
            }
        }
        this.spinner.show()
        this.liquidationService.addLiquidation(dto)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        let res = x.data as IDtoLiquidation;
                        this.liquidation.id = res.id;
                        if (dto.conciliationCustomer > 0) {
                            this.upload(res, false);
                        }
                        if(this.shouldShowCheckbox()){
                            if (dto.approvalConciliationOwnSent && this.approvalConciliationOwnSent == false) {
                                this.sentApproveConciliationOwn(dto.conciliationOwn, dto.id);
                            }
                        }
                        this.getLiquidation();
                    }
                    this.spinner.hide();
                },
                (errMessage) => {
                    this.spinner.hide();
                    this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                });
    }
    private updateLiquidation(): void {
        let dto = this.mapLiquidationData(this.liquidation);
        if (dto.conciliationCustomer > 0 && dto.conciliationCustomer != this.amountCustomer) {
            if (this.file == undefined) {
                this.configGeneral.newToast('Validación', 'Seleccione un archivo como soporte de autorización de conciliación del cliente.', 'error');
                return;
            }
        }
        const conciliationValue = Number(dto.conciliationOwn);
        if (conciliationValue > 0) {
            if (this.approver == undefined) {
                this.configGeneral.newToast('Validación', 'No existe un aprovador disponible para realizar la aprobación de la conciliación propia.', 'error');
                return;
            }
        }

        this.spinner.show()
        this.liquidationService.updateLiquidation(dto)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        if (dto.conciliationCustomer > 0) {
                            this.upload(dto, true);
                        }
                        if(this.shouldShowCheckbox()){
                            if (dto.approvalConciliationOwnSent && this.approvalConciliationOwnSent == false) {
                                this.sentApproveConciliationOwn(dto.conciliationOwn, dto.id);
                            }
                        }
                        this.getLiquidation();
                        // if (this.module == 'demand') {
                        //     this.dataLiquidation.emit(dto);
                        // }
                    }
                    this.spinner.hide();
                },
                (errMessage) => {
                    this.spinner.hide();
                    this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                });
    }
    private getLiquidationById(): void {
        this.spinner.show()
        this.liquidation = {} as IDtoLiquidation;
        this.liquidationService.getLiquidationById(this.liquidationId)
            .subscribe(
                (x) => {
                    if (x != null) {
                        this.liquidation = x;
                        this.amountCustomer = this.liquidation.conciliationCustomer;
                        this.amountOwner = this.liquidation.conciliationOwn;
                        this.approvalConciliationOwnSent = this.liquidation.approvalConciliationOwnSent;
                        this.formLiquidationDetail.patchValue(this.liquidation);
                        if (this.liquidation.documentApproval) {
                            this.fileName = this.liquidation.documentApproval.fileName;
                        }
                    } else {
                        this.configGeneral.newToast('Error', "No existen datos para mostrar", 'error');
                    }
                    this.spinner.hide();
                },
                (errMessage) => {
                    this.spinner.hide();
                    this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                });
    }
    private getLiquidationDetail(): void {
        let dto = this.mapLiquidationData(this.liquidation);
        this.getDetailsDescriptionDiscounts();
        this.getLiquidation();
        this.getDetailSettlementEmployee(dto);
    }
    private onFileChange(event) {
        event.value = '';
    }
    private handleFileInput(event) {
        this.file = event.target.files[0];;
        this.fileName = this.file.name;
    }
    private upload(liquidation: IDtoLiquidation, isReplaced: boolean): void {
        if (this.file != undefined) {
            this.spinner.show();
            let document = {} as IDtoDocument;
            const fileName = this.file.name;
            let sp = fileName.split('.').pop();
            let fileNameNew = `${liquidation.employeeId}_AutorizacionConciliacionCliente_${this.datePipe.transform(new Date(), 'ddMMyyyy')}.${sp}`;
            document.fileName = fileNameNew;
            this.fileName = fileNameNew;
            document.referenceId = liquidation.id;
            document.folder = 'AutorizacionesConciliacionCliente';
            document.module = this.module;
            document.name = "AutorizacionConciliacionCliente";
            document.acceptDuplicate = true;
            document.isReplaced = isReplaced;
            this.documentService.addDocument(document, this.file).subscribe((res) => {
                if (res.isCorrect === true) {
                    this.configGeneral.newToast('Éxito', res.message, 'success');
                    this.document = res.data as IDtoDocument;
                    this.fileName = this.document.fileName;
                    this.addModuleLog(this.document.id, 'addDocument');
                } else {
                    this.configGeneral.newToast('Error', res.message, 'error');
                }
                this.spinner.hide();
            },
                (errMessage) => {
                    this.spinner.hide();
                    this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                });
        }
    }
    private addModuleLog(id: number, action: string): void {
        let dto = {} as IDtoModuleLog;
        dto.table = 'Documents';
        dto.module = this.module;
        dto.action = action;
        dto.registryAffectedId = id;
        this.identityService.addModuleLog(dto).subscribe(
            (x) => { });
    }
    shouldShowCheckbox(): boolean {
        const dailySalary = this.employeeData == undefined ? 0 : this.employeeData.dailySalary;
        const conciliationValue = this.formLiquidationDetail.get('conciliationOwn').value;
        const threshold = (dailySalary * 90) * 0.4;
        return conciliationValue > threshold;
      }
    private sentApproveConciliationOwn(conciliationOwn: number, liquidationId: number): void {
        const json = {
            employeeName: this.employeeData.employeeName
            , employeeNum: this.employeeData.employeeNum
            , job: this.employeeData.employeeJob
            , trademark: this.employeeData.employeeMarkName
            , hiringDate: this.employeeData.hiringDate
            , workingDayName: this.employeeData.workingDayName
            , company: this.employeeData.employeeCompany
            , typePayroll: this.employeeData.employeeTypePayroll
            , town: this.employeeData.town
            , positionNo: this.employeeData.positionNo
            , plan: this.employeeData.planName
            , projectName: this.employeeData.projectName
            , dismissalDate: this.employeeData.dismissalDate
            , dismissalCause: this.employeeData.dismissalCause
            , billCompanyId: this.employeeData.companyPayRegId
            , conciliationOwn: conciliationOwn
            , liquidationId: liquidationId
        };

        this.spinner.show();
        let message = '';
        let email = {} as IDtoEmail;

        email.fromSubject = 'Redpromex';
        email.userId = this.approver;
        email.subject = 'Aprobación conciliación propia';
        email.toRol = 'Aprobador';
        email.json = JSON.stringify(json)
        email.template = 'approve_conciliation_own';
        email.moduleName = 'liquidation'
        email.status = 1;
        this.emailService.addEmail(email).subscribe((res) => {
            if (res.isCorrect === true) {
                this.configGeneral.newToast('Éxito', res.message, 'success');
            } else {
                this.configGeneral.newToast('Error', res.message, 'error');
            }
            this.spinner.hide();
        },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
            });
    }
    private getApproverConciliationOwn(): void {
        this.liquidationService.getApproverConciliationOwn()
            .subscribe(
                (x) => {
                    this.approver = x.data.toString();
                },
                (errMessage) => {
                    this.spinner.hide();
                    this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                });
    }
    private sentRequestMoney(): void {
        let dto = this.mapLiquidationData(this.liquidation);
        this.spinner.show()
        this.liquidationService.sentRequestMoney(dto)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                    }
                    this.spinner.hide();
                },
                (errMessage) => {
                    this.spinner.hide();
                    this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                });
    }
}
